// types
import { i18nNavigation } from 'models/i18n';

// ==============================|| I18N SK NAVIGATION ||============================== //

const skNavigation: i18nNavigation = {
  dispatcher: {
    group: 'Prevádzkové riadenie',
    onlineDispatching: 'Online dispečing',
    onlineDispatchingDeliveryPoint: 'Odberné miesto',
    onlineDispatchingDevice: 'Zariadenie',
    productionPlanning: 'Plánovanie produkcie',
    operationCalendar: 'Operačný kalendár',
    consumptionPlanning: 'Plánovanie spotreby',
    operatingCalendar: 'Operačný kalendár',
    hxDashboard: 'Protiodchýlkovanie H + X',
    rkDashboard: 'Stráženie RK'
  },
  digiTwin: {
    group: 'DigiTwin'
  },
  reporting: {
    group: 'Prehľady',
    marketImbalance: 'Trhová odchýlka',
    balancingGroup: 'Bilančná skupina',
    deviceProductionPlan: 'Plán produkcie zariadení',
    deliveryPointProductionPlan: 'Plán produkcie odberných miest',
    economicBenefits: 'Ekonomické prínosy bilančnej skupiny'
  },
  eai: {
    group: 'Manažment zdrojov',
    users: 'Používatelia',
    userList: 'Zoznam používateľov',
    userDetail: 'Detail používateľa',
    userAssignment: 'Priradenie používateľa',
    userWizard: 'Vytvorenie používateľa',
    subjects: 'Subjekty',
    subjectList: 'Zoznam subjektov',
    subjectDetail: 'Detail subjektu',
    subjectWizard: 'Vytvorenie subjektu',
    deliveryPoints: 'OOM',
    deliveryPointList: 'Zoznam OOM',
    deliveryPointDetail: 'Detail OOM',
    deliveryPointWizard: 'Vytvorenie OOM',
    deliveryPointGdsList: 'Zoznam GDS',
    deliveryPointGdsDetail: 'GDS Detail',
    balanceGroups: 'Bilančné skupiny',
    balanceGroupDetail: 'Detail bilančnej skupiny',
    devices: 'Zariadenia',
    deviceList: 'Zoznam zariadení',
    deviceDetail: 'Detail zariadenia',
    deviceWizard: 'Vytvorenie zariadenia',
    deviceCharacteristicGroupWizard: 'Vytvorenie skupiny zariadenia',
    deviceGroupDetail: 'Skupina zariadenia',
    deliveryContracts: 'Dlhodobé kontrakty',
    deliveryContractWizard: 'Vytvorenie dlhodobého kontraktu',
    deliveryContractDetail: 'Detail dlhodobého kontraktu'
  },
  system: {
    group: 'Správa systému',
    activityEvents: 'Prehľad udalostí',
    alarms: 'Alarmy'
  }
};

export default skNavigation;
